import React from 'react';
interface SupplementCalloutProps {
  title: string;
  description: string;
  qrPlaceholder?: boolean;
}
export function SupplementCallout({
  title,
  description,
  qrPlaceholder = true
}: SupplementCalloutProps) {
  return <div className="border-l-2 border-tealslate bg-navyslate px-3 py-2 flex gap-2 items-start mt-auto" data-id="element-3513">
      <div className="flex-1 min-w-0" data-id="element-3514">
        <span className="text-[12px] font-bold text-white" data-id="element-3515">{title}</span>
        <span className="text-[12px] text-[#E0E0E0] italic ml-1.5" data-id="element-3516">
          {description}
        </span>
      </div>
      {qrPlaceholder && <div className="w-3 h-3 border border-darkgray bg-nearblack flex items-center justify-center shrink-0 mt-0.5" data-id="element-3517">
          <span className="text-[4px] text-[#9CA3AF] font-bold leading-none" data-id="element-3518">
            QR
          </span>
        </div>}
    </div>;
}